/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Accounts } from '../../models/accounts';

export interface GetAccountInfo$Params {
}

export function getAccountInfo(http: HttpClient, rootUrl: string, params?: GetAccountInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<Accounts>> {
  const rb = new RequestBuilder(rootUrl, getAccountInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Accounts>;
    })
  );
}

getAccountInfo.PATH = '/account/info';
